angular.module('app.controllers').controller 'ExhibitorsViewCtrl', [
  '$scope', '$rootScope', 'APIExhibitors', 'UI', 'APIRead', 'APIChats', '$interval', 'ngMeta'
].append (self, root, APIExhibitors, UI, APIRead, APIChats, $interval, ngMeta) ->
      
  self.id = parseInt(self.get('id')) || null
  
  if root.user?.role == 'exhibitor'      
    return root.logout() unless self.id == root.session?.user?.id

  APIExhibitors.get {id: self.id, _entry: 'exhibitor', lang: 'en', country: root.session?.user.country}, (data) ->
    
    self.data = data
    self.data.infos = self.data.infos.map (block) ->
      return block unless block.pathfactory
      url = new URL(block.pathfactory)
      url.searchParams.set('lb_email', root.session?.user?.email || 'unlock-the-future.industry@siemens.com')
      block.pathfactory = url.toString()
      return block

    self.data.usecase_order = [] unless self.data.usecase_order?
    
    self.infos = self.data.infos.filter((info) -> return !info.is_suc) || [] 
    self.solutions = self.data.infos.map((info) -> 
      info.exhibitor_id = self.data.exhibitor_id
      return info
    ).filter((info) -> return info.is_suc) || []

    self.customStat(self.id, 'page_view', "Page #{self.data.title} opened")

    getChatRooms()

    APIRead.query {entry_type: 'usecase', campaign: (if self.data.exhibitor_type is 'campaign' then self.data.id else self.data.campaign_id), exclude: self.id, lang: 'en'}, (data) ->
      self.usecases = data.map (item, index, array) ->
        if item.exhibitor_id in self.data.usecase_order
          item.sortIndex = self.data.usecase_order.indexOf(item.exhibitor_id)
        else
          item.sortIndex = array.length + 1
        return item
    , (response) ->
      UI.notify false, response.data.error

    if self.data.exhibitor_type is 'campaign'
      APIRead.query {entry_type: 'campaign', limit: 3, random: true, full: true, splice: true, exclude: self.id, lang: 'en'}, (data) ->
        self.campaigns = data
      , (response) ->
        UI.notify false, response.data.error

  , (response) ->
    UI.notify false, response.data.error


  self.trackBlock = (block) ->
    return unless block.track_in
    block.tracked = true
    self.customStat(self.id, block.track_in_key || "", block.track_in_description || "", true, block.id)


  #
  # Chats logic
  #
  
  self.rooms = []
  
  getChatRooms = () ->
    return false
    accounts = self.data.presenter_contact_persons?.map((contact) -> return contact.chataccount).filter((contact) -> return contact)
    return unless accounts.length

    rooms = []
    APIChats.query {_entry: 'meetings', accounts: accounts.join(","), include_offline: true}, (data) ->
      data.forEach (item) ->
        self.data.presenter_contact_persons.find((contact) -> contact.chataccount == item.account.id)?.room = item
         
      #self.joinChat(self.rooms[0], self.data.title, false) if self.rooms.length

      
  roomsInterval = $interval getChatRooms, 10000

  self.openChat = (room) ->
    self.joinChat(room, self.data.title, false)
    
  self.$on '$destroy', ->

    if angular.isDefined(roomsInterval)
      $interval.cancel(roomsInterval)
      roomsInterval = undefined